import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Permission } from '@tcc-mono/classifact/shared/data-access/models';
import { AuthenticationService } from '@tcc-mono/shared/authentication/passport';
import { map, Observable, BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private _permissions = new BehaviorSubject<Permission[]>([]);
  public permissions$ = this._permissions.asObservable();

  public constructor(
    private readonly _authService: AuthenticationService
  ) {
    this._authService.me$
      .pipe(untilDestroyed(this))
      .subscribe((me) => {
        // Als me null is → fallback naar lege array
        const perms = me?.permissions ?? [];
        this._permissions.next(perms);
      });
  }

  public canEdit(page: string): boolean {
    return true;
  }

  public getAll(): Observable<Permission[]> {
    return this._authService.me$
      .pipe(
        map((me) => me?.permissions ?? [])
      );
  }

  public hasPermission(permission: string): Observable<boolean> {
    return this.permissions$
      .pipe(
        map((permissions) =>
          permissions.some((p: Permission) => p.name === permission)
        )
      );
  }
}
